var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEpLogoDashboardNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207.833,
    height: 22.951,
    viewBox: "0 0 207.833 22.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "easypay_white",
    "data-name": "easypay white",
    transform: "translate(-507.795 -351.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4059",
    "data-name": "Group 4059",
    transform: "translate(507.795 351.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8251",
    "data-name": "Path 8251",
    d: "M2865.355,1190.065l-12.2,22.852h5.211l3.766-7.046h10.48l3.873,7.051h7.089l-12.587-22.847Zm4.757,11.3-5.571-.008,2.745-5.147Z",
    transform: "translate(-2822.115 -1189.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8252",
    "data-name": "Path 8252",
    d: "M3485.771,1190a6.233,6.233,0,0,0-1.858,1.5,6.723,6.723,0,0,0-1.232,2.115,7.01,7.01,0,0,0-.455,2.52,7.658,7.658,0,0,0,.433,2.546,8.024,8.024,0,0,0,1.205,2.217,6.612,6.612,0,0,0,1.85,1.613,4.827,4.827,0,0,0,2.439.664l14.107.013a2.544,2.544,0,0,1,.9.166,1.957,1.957,0,0,1,.679.438,1.987,1.987,0,0,1,.453.674,2.215,2.215,0,0,1,.168.916,2.65,2.65,0,0,1-.187.987,2.371,2.371,0,0,1-.486.79,2.136,2.136,0,0,1-.715.518,1.792,1.792,0,0,1-.829.179l-20.051-.015v4.446h23.348a3.672,3.672,0,0,0,1.754-.567,6.384,6.384,0,0,0,1.848-1.6,7.752,7.752,0,0,0,1.2-2.2,7.45,7.45,0,0,0,.441-2.534,6.867,6.867,0,0,0-.441-2.524,7,7,0,0,0-1.227-2.116,6.069,6.069,0,0,0-1.857-1.5,5.364,5.364,0,0,0-2.4-.6h-14.093a2.02,2.02,0,0,1-.838-.183,2.214,2.214,0,0,1-.709-.531,2.553,2.553,0,0,1-.49-.786,2.784,2.784,0,0,1-.178-1.016,2.281,2.281,0,0,1,.162-.885,2.086,2.086,0,0,1,.456-.678,1.912,1.912,0,0,1,.681-.432,2.275,2.275,0,0,1,.916-.153l20.033.017.014-4.547-22.65-.05A5.136,5.136,0,0,0,3485.771,1190Z",
    transform: "translate(-3418.387 -1189.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8253",
    "data-name": "Path 8253",
    d: "M2264.886,1196.719v-.005a6.9,6.9,0,0,1,1.375-1.964,6.277,6.277,0,0,1,1.914-1.3,5.46,5.46,0,0,1,2.286-.458l15.583.013v-4.541l-17.993-.023a9.982,9.982,0,0,0-5.376,1.586,10.6,10.6,0,0,0-2.137,1.8,11.1,11.1,0,0,0-1.646,2.314,11.945,11.945,0,0,0-1.059,2.732,12.3,12.3,0,0,0-.38,3.036,12.559,12.559,0,0,0,.38,3.045,12.163,12.163,0,0,0,1.054,2.732,11.3,11.3,0,0,0,1.638,2.315,10.461,10.461,0,0,0,4.672,2.985,10.022,10.022,0,0,0,2.844.4l17.994-.019v-4.514h-15.6a5.5,5.5,0,0,1-2.273-.452,6.279,6.279,0,0,1-1.914-1.293,6.824,6.824,0,0,1-1.376-1.951,7.641,7.641,0,0,1-.368-.968l21.575.026v-4.536l-21.567-.019A6.922,6.922,0,0,1,2264.886,1196.719Z",
    transform: "translate(-2257.454 -1188.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8254",
    "data-name": "Path 8254",
    d: "M4092.985,1197.717l-7.742-7.571h-9.021l12.934,12.6-.01,10.252h6.7l.01-10.931,13.131-11.909H4101.3Z",
    transform: "translate(-3981.462 -1190.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8255",
    "data-name": "Path 8255",
    d: "M5199.061,1189.684h-5.411l-12.169,22.87h4.663l3.857-7.246,11.047.017,3.976,7.245h6.587l-12.426-22.658Zm-.212,11.606-6.7-.009,3.3-6.19Z",
    transform: "translate(-5029.135 -1189.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8256",
    "data-name": "Path 8256",
    d: "M5656.781,1189.532l-8.6,7.859-8.037-7.872h-8.381l12.792,12.463v10.41h6.278l.011-11.105,12.947-11.751Z",
    transform: "translate(-5455.96 -1189.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8257",
    "data-name": "Path 8257",
    d: "M4776.668,1201.1v0a7.455,7.455,0,0,0,1.168-2.178,9.464,9.464,0,0,0,.426-2.794,6.954,6.954,0,0,0-.329-2.141l-.354-.932h-.024a6.848,6.848,0,0,0-.921-1.418,5.829,5.829,0,0,0-1.8-1.448,4.991,4.991,0,0,0-2.285-.585l-21.446-.023v22.871h5.67l.033-9.2h15.708a4.738,4.738,0,0,0,2.357-.59A6.345,6.345,0,0,0,4776.668,1201.1Zm-4.253-4.82a2.827,2.827,0,0,1-.182.942l-.163.368a4.069,4.069,0,0,1-.258.389,1.908,1.908,0,0,1-.156.167,2.32,2.32,0,0,1-.7.527l-.1.051a2.785,2.785,0,0,1-1.021.213l-13.049-.012v-5.336l13.064.013a2.933,2.933,0,0,1,1.055.186,2.294,2.294,0,0,1,.764.486,2.509,2.509,0,0,1,.731,1.892Z",
    transform: "translate(-4621.181 -1189.516)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpLogoDashboardNew);
export default __webpack_public_path__ + "static/media/epLogoDashboardNew.38d33eb610e52cdbffd062b0e9f43345.svg";
export { ForwardRef as ReactComponent };